<template>
    <data-table
        :customizeTable="{
            labelLoading: 'Chargement...',
            labelDetails: ''
        }"
        :loading="loading"
        :data="subscriptions"
        :headers="columns">
        <template #withPerPage>
            <with-per-page
                :customizeTable="{
                    labelShowing: '',
                    labelEntries: '',
                    entries: [10, 15, 20, 25, 30],
                }"
                @makeSelected="makeSelected($event)"
            />
        </template>


        <template #withSearch>
            <div class="btn-group btn-group-sm mb-1" role="group">
                <button type="button" class="btn" :class="query.state === '' ? 'btn-primary' : 'btn-outline-primary'" @click="filterByState('')">Toutes</button>
                <button type="button" class="btn" :class="query.state === 'valid' ? 'btn-success' : 'btn-outline-success'" @click="filterByState('valid')">En cours</button>
                <button type="button" class="btn" :class="query.state === 'expired' ? 'btn-warning' : 'btn-outline-warning'" @click="filterByState('expired')">Expirées</button>
            </div>
        </template>

        <template #withBody>
            <tr v-for="(item, i) in subscriptions" :key="i" @click="$router('souscriptions/show/'+item.uuid)" style="cursor:pointer">
                <td>{{ item.id }}</td>
                <td>{{ item.name }}</td>
                <td>{{ item.product }}</td>
                <td>{{ $format(item.amount) }}</td>
                <td>{{ item.created_at }}</td>
                <td>
                    <span v-if="item.status === 'add'" class="badge badge-pill badge-info">Paiement à la livraison</span>
                    <span v-if="item.status === 'negotiated' && item.amount_negotiated !== null" class="badge badge-pill badge-info">Négocié</span>
                    <span v-if="item.status === 'paid'" class="badge badge-pill badge-success">Payé</span>
                    <span v-if="item.status === 'negotiated' && item.amount_negotiated === null" class="badge badge-pill badge-info">En négociation</span>
                </td>
                <td>
                    <a v-if="item.status === 'paid'" :href="'/api/subscriptions/' + item.uuid + '/invoice'" target="_blank" class="btn btn-sm btn-outline-primary" @click.stop>
                        <i class="fa fa-download"></i> Facture
                    </a>
                </td>
            </tr>
        </template>
    </data-table>
</template>

<script>
    import WithPerPage from "../../../../components/customTable/elements/withPerPage";
    import WithSearch from "../../../../components/customTable/elements/withSearch";
    import WithPagination from "../../../../components/customTable/elements/withPagination";
    import DataTable from "../../../../components/customTable/dataTable";
    import axios from "axios";
    import {api, _buildQuery } from "../../../../helpers/shared";

    const default_customize = {
        labelShowing: 'Show',
        labelEntries: 'entries',
        entries: [10, 15, 20, 25, 30],
        labelSearch: 'Search',
        labelLoading: 'Loading...',
        labelDetails: 'Showing 0 to 0 of 0 entries'
    };

    export default {
        name: "allSubscription",
        components: {WithPerPage, WithSearch, WithPagination, DataTable},
        props: ['content'],
        data: () => ({
            columns: [
                {title: 'id', key: 'reference'},
                {title: 'client', key: 'name'},
                {title: 'produit', key: 'product'},
                {title: 'montant(Fcfa)', key: 'amount'},
                {title: 'date', key: 'created_at'},
                {title: 'statut', key: 'status'},
                {title: 'actions', key: 'actions'},
            ],
            loading: false,
            links: [],
            subscriptions: [],
            query:{
                page: 1,
                per: 10,
                namespace: 'all',
                product: '',
                state: ''
            }
        }),
        mounted() {
            this.subscriptions = [ ...this.content.data ];
        },
        methods:{

            filterByState(state) {
                this.query.state = state;
                this.query.page = 1;
                this.makeFilter(this.query);
            },

            makeFilter(query){
                this.query = { ...query };
                this.loading = true;
                axios.get(api('load-subscription'+_buildQuery(this.query)))
                    .then((response) => {
                        let content = response.data;
                        this.subscriptions = content.data;
                        this.loading = false;
                    }).catch((error) => {
                    if (error.response.status === 422){
                        this.loading = false;
                        this.errors = error.response.data.errors
                    }else this.$toasted.global.error({message: "Votre connexion a expiré"})
                })
            },

            makeSelected(val){
                this.loading = true;
                this.query.per = val;
                axios.get(api('load-subscription'+_buildQuery(this.query)))
                    .then((response) => {
                        let content = response.data;
                        this.subscriptions = content.data;
                        this.loading = false;
                    }).catch((error) => {
                    if (error.response.status === 422){
                        this.loading = false;
                        this.errors = error.response.data.errors
                    }else this.$toasted.global.error({message: "Votre connexion a expiré"})
                })
            },
        }
    }
</script>

<style scoped>

</style>
